import React from 'react';
import PropTypes from 'prop-types';


const UnsupportedNotification = (props) => (
  <p>
    Unsupported notification, type: {props.message.type}
  </p>
);

UnsupportedNotification.propTypes = { message: PropTypes.object.isRequired };

export default UnsupportedNotification;
